export enum ZINDEX {
    FRAME = 3,
    VIDEO = 5,
    LOGO = 8,
    GRAPHIC = 9,
    SLIDE = 10,
    CLOSED_CAPTION = 15,
    OUTRO = 16,
    PEECH_WATERMARK = 20,
}